module.exports = __webpack_public_path__ + "static/img/gx_shexiangtou.db6a735a.png";